<template>
  <b-card-code title="چیدمان محتوا">





    <div class="custom-search  justify-content-end">
      <b-form-group
          label="انتخاب دسته محتوا (اجباری)"
          label-for="mother-categories"
      >
        <b-form-select
            id="mother-categories"
            v-model="categoryID"
            :options="categories"
            @change="getContentForArrange(1)"

        />
      </b-form-group>
    </div>

    <draggable
        v-model="rows"
        class="list-group list-group-flush cursor-move"
        tag="ul"
    >
      <transition-group
          type="transition"
          name="flip-list"
      >
        <b-list-group-item
            v-for="listItem in rows"
            :key="listItem.id"
            tag="li"
        >
          <div class="d-flex">
            <div class="ml-25">
              <b-card-text class="font-weight-bold mb-0">
                {{ listItem.title }}
              </b-card-text>
            </div>
          </div>
        </b-list-group-item>
      </transition-group>
    </draggable>


<b-row>
  <b-col cols="12" class="mt-4">
    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="mr-1"
        @click="submitArrange"
        variant="success"
    >
      ثبت
    </b-button>
  </b-col>
</b-row>

  </b-card-code>

</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BBadge,BRow,BCol, BPagination, BFormGroup, BButton, BFormInput, BFormSelect, BDropdown, BDropdownItem,BListGroupItem
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import contentRepository from "@/modules/contents/services/contentRepository";
import {$themeConfig} from "@themeConfig";
import router from "@/router";
import Swal from 'sweetalert2'
import galleryRepository from '@/modules/gallery/services/galleryRepository'
import categoryRepository from '@/modules/categories/services/categoryRepository'
import * as contentRepositoryon from 'core-js'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: "listContent",
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    draggable,
    BCol,
    BRow,
    BListGroupItem,
    Prism,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      categoryID: 0,
      categories: [],
      rows:[]
    }
  },
  computed: {
  },
  async created() {
    await this.getCategories()
    // await this.getContentForArrange(1);
  }, methods: {
    async submitArrange(){


      let body =  {
        contentsPriorty: [
        ]
      };



      for (let i = 0; i <this.rows.length; i++) {
        body.contentsPriorty.push({
          id: this.rows[i].id,
          priorty: i
        })
      }

      const {data} = await contentRepository.submitContentArragne(body)

      if (data.isSuccess) {
        await Swal.fire({
          confirmButtonText: 'ok',
          title: 'موفقیت',
          html: 'عملیات با موفقیت انجام شد',
          icon: 'success'
        });
        // this.$router.replace('/gallery/list')
        // await router.push('/gallery/list')

        this.gotolist()

      } else {
        await Swal.fire('هشدار', data.message, 'warning');
      }



    },
    async getCategories() {
      const {data} = await categoryRepository.get({});
      if (data.isSuccess) {
        let cats = data.data.data.map(p => {
          return {
            value: p.id, text: p.title
          }
        });
        cats.forEach(p => {
          this.categories.push(p);
        })
      }
    },
    async getContentForArrange(pageNo) {

      let query = '?categoryId=' + this.categoryID;


      const {data} = await contentRepository.getContentForArragne(query);

      if (data.isSuccess) {
        this.rows = data.data.map((p) => {
          return {
            title: p.title,
            id: p.id ,
          }
        });
        console.log(this.rows)
      }
    },
    gotolist() {
      router.push('/contents/list')
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.list-group-item {
  transition: all 1s
}

</style>
